import { useEffect, useState } from "react";
import { IntervalPageResponse, Labels } from "../../../net/response";
import { FlatList, Pressable, Text, View } from "react-native";
import { black, ColorLine, white } from "../../../assets/style/colors";
import {
  Str_Cancel,
  Str_Complete,
  Str_Second,
  Str_SetFail,
} from "../../../language/string_res";
import { intervalPage } from "../../../net/service";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { hideLoading, showLoading } from "../../../components/Loading";
import { postJson } from "../../../net/http";
import { showToast } from "../../../components/Toast";
import { ListEmpty } from "../../../components/ListEmpty";
import { CheckBoxView } from "../../../components/CheckBoxView";
import { ScreenCancelModal } from "../../../components/ScreenModal";
export type SettingIntervalTimeProps = {
  tid: string;
  curTime: string;
};
export const SettingIntervalTime = ({
  navigation,
  route,
}: MainNavProps<"SettingIntervalTime">) => {
  const props = route.params;
  const [data, setData] = useState<IntervalPageResponse>();
  const [curTime, setCurTime] = useState(props.curTime);
  useEffect(() => {
    intervalPage({ tid: props.tid }).then((res) => {
      if (res.code === 0) {
        setData(res.data);
      }
    });
  }, []);
  const SelectTime = (item: Labels) => {
    setCurTime(`${item.interval_second}`);
  };
  const done = () => {
    const body = { tid: props.tid, group_chat_interval_time: curTime };
    showLoading();
    postJson<any>(`/v1/sdk/group/profile/set`, { body })
      .then((res) => {
        hideLoading();
        if (res.code === 0) {
          navigation.goBack();
        } else {
          showToast(res.msg || Str_SetFail);
        }
      })
      .catch((err) => {
        showToast(err.msg || Str_SetFail);
        hideLoading();
      });
  };
  const renderItem = ({ item }: { item: Labels }) => {
    return (
      <Pressable
        style={{
          flexDirection: "row",
          paddingVertical: 14,
          alignItems: "center",
          paddingStart: 16,
          backgroundColor: white,
          justifyContent: "space-between",
        }}
        onPress={() => SelectTime(item)}
      >
        <Text
          style={{ fontSize: 17, color: black }}
        >{`${item.interval_second} ${Str_Second}`}</Text>
        <CheckBoxView
          value={curTime === `${item.interval_second}`}
          onValueChange={() => SelectTime(item)}
          style={{ width: 24, height: 24, marginEnd: 16, marginLeft: "auto" }}
        />
        <View
          style={{
            position: "absolute",
            bottom: 0,
            start: 0,
            end: 0,
            height: 0.3,
            backgroundColor: ColorLine,
          }}
        />
      </Pressable>
    );
  };

  return (
    <ScreenCancelModal
      title={data?.title}
      onRightPress={done}
      leftText={Str_Cancel}
      rightText={Str_Complete}
      onLeftPress={navigation.goBack}
    >
      <FlatList
        style={{ marginTop: 18, marginHorizontal: 10, borderRadius: 5 }}
        data={data?.labels}
        keyExtractor={(item) => item.interval_second.toString()}
        ListEmptyComponent={<ListEmpty />}
        renderItem={renderItem}
      />
    </ScreenCancelModal>
  );
};
